module.exports = __webpack_public_path__ + "static/img/leemma_logo_blue.969af0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leemma_logo_blue.png
// module id = hXAl
// module chunks = 1